export default __webpack_public_path__ + "static/media/panaca.7f955658.jpeg";